export default __webpack_public_path__ + "636ecdd.png";